import { render } from "./shieldpage.vue?vue&type=template&id=168fd188"
import script from "./shieldpage.vue?vue&type=script&lang=js"
export * from "./shieldpage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__